import React from 'react';
import { Link } from "react-router-dom";

const BackofficeProfileLink = ({profileUuid, children}: {profileUuid: string, children: any}) => {
    return (
        <Link to={`/dashboard/profiles/${profileUuid}`}>
            {children}
        </Link>
    );
};

export default BackofficeProfileLink;